module.exports = __webpack_public_path__ + "static/media/landing page (2).f5521c49.png";